import AnalyticsProvider from "AnalyticsDashboard/components/AnalyticsProvider";
import AnalyticsQuery from "AnalyticsDashboard/components/AnalyticsQuery";

export default function NewAnalytics() {
  return (
    <div className="analytics">
      <AnalyticsProvider>
        <div className='row'>
          <div className='column half'>
            <AnalyticsQuery
              kind="emails"
              chartType="line"
              dimensions={[{ id: 'time', timeBucket: 'day' }]}
            />
          </div>
          <div className='column half'>
            <AnalyticsQuery kind='emails' chartType='table'
              metrics={[{ id: 'count' }, { id: 'open_rate' }, { id: 'click_rate' }]}
              dimensions={[{ id: 'campaigns_campaign_name' }]}
              primaryDimension={{ id: 'campaignsCampaignName', label: 'Campaign' }}
              orderBy={[{ kind: 'metric', id: 'open_rate', direction: 'desc' }]}
              limit={10}
            />
          </div>
        </div>
      </AnalyticsProvider>
    </div>
  );
}
